import api from "../../index";

export const GetActivityApi = () => api.post('user-activity-log');